import { Flex } from "@chakra-ui/layout";
import { Tooltip } from "antd";
import { MdFastForward, MdSchedule, MdDescription, MdInfo } from "react-icons/md";
import { useFilters } from "core/features/filters/store";
import useStore from "../../hooks/useStore";
import OperacoesTable from "./OperacoesTable";
import {
  StyledModal,
  Title,
  ContentButton,
  ButtonStyled,
  ButtonStyledLink,
  StyledTag,
  Warning,
} from "../../styles";

interface ModalMatrizProps {
  data: any[];
  planoOperacionalData: any;
  talhoesIds: any[];
  isLoading: boolean;
  action: "antecipar" | "prorrogar" | "justificar";
  isOpen: boolean;
  onClose: () => void;
  next: () => void;
}

function ModalMatriz({
  data,
  planoOperacionalData,
  talhoesIds,
  isLoading,
  action,
  isOpen,
  next,
  onClose,
}: ModalMatrizProps) {

  const { planoOperacionalOperacaoTalhaoIds } = useStore();

  const { filters } = useFilters();
  const { filtersAdvanced } = filters;
  const { classeOperacao } = filtersAdvanced;

  const filtrosAvancados = planoOperacionalData?.filtrosAvancados;
  const operacaoClasses = filtrosAvancados?.operacaoClasses;
  const classesOperacoes = classeOperacao?.map(item => {
    const classe = operacaoClasses?.find((i: any) => i.operacaoClasseId === item);
    return classe?.descricao;
  });

  const classes = Array.from(new Set(classesOperacoes));

  function getTitle() {
    if (action === "antecipar") {
      return (
        <>
          <MdFastForward color="#fff" size={28} />
          Antecipar Operação - Seleção de Sequências
        </>
      );
    }
    if (action === "prorrogar") {
      return (
        <>
          <MdSchedule color="#fff" size={28} />
          Prorrogar Operação - Seleção de Sequências
        </>
      );
    }
    if (action === "justificar") {
      return (
        <>
          <MdDescription color="#fff" size={28} />
          Justificar Atraso - Seleção de Sequências
        </>
      );
    }
  }

  function getWarningText() {
    if (action === "antecipar") {
      return "antecipadas";
    }
    if (action === "prorrogar") {
      return "prorrogadas";
    }
    if (action === "justificar") {
      return "justificadas";
    }
  }

  return (
    <StyledModal
      centered
      color="#12619C"
      width={"95%"}
      zIndex={999999}
      visible={isOpen}
      onCancel={onClose}
      title={<Title>{getTitle()}</Title>}
      footer={
        <Flex justifyContent="end" alignItems="center">
          <ContentButton>
            <ButtonStyledLink
              size="large"
              onClick={onClose}
              loading={isLoading}
            >Cancelar</ButtonStyledLink>
            <ButtonStyled
              color="#12619C"
              type="primary"
              size="large"
              onClick={next}
              loading={isLoading}
              disabled={planoOperacionalOperacaoTalhaoIds.length === 0}
            >Confirmar Seleção</ButtonStyled>
          </ContentButton>
        </Flex>
      }
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        borderBottom="1px solid #cecece"
        padding={4}
      >
        <Flex gridGap={8} alignItems="center">
          <div>
            <p style={{ color: "#666666", fontWeight: 600 }}>Talhões Selecionados</p>
            <Flex gridGap={1} marginTop={1}>
              {data?.slice(0, 4)?.map((item: any) => (
                <StyledTag color="blue">{item.codigo}</StyledTag>
              ))}
              {data?.length > 4 && (
                <Tooltip title={data?.slice(4)?.map((item: any) => item.codigo)?.join(", ")}>
                  <StyledTag color="blue">+{data?.slice(4)?.length}</StyledTag>
                </Tooltip>
              )}
            </Flex>
          </div>
          {classes?.length > 0 && (
            <div>
              <p style={{ color: "#666666", fontWeight: 600 }}>Classes de Operação</p>
              <Flex gridGap={1} marginTop={1}>
                {classes?.slice(0, 4)?.map((item: any) => (
                  <StyledTag color="green">{item}</StyledTag>
                ))}
                {classes?.length > 4 && (
                  <Tooltip title={classes?.slice(4)?.map((item: any) => item)?.join(", ")}>
                    <StyledTag color="green">+{classes?.slice(4)?.length}</StyledTag>
                  </Tooltip>
                )}
              </Flex>
            </div>
          )}
        </Flex>

        <Flex gridGap={8} alignItems="center" textAlign="center">
          <div>
            <b style={{ color: "#2196f3" }}>{talhoesIds.length ?? 0}</b>
            <p>TALHÕES</p>
          </div>
          <div>
            <b style={{ color: "#2196f3" }}>0</b>
            <p>SEQUÊNCIAS SELECIONADAS</p>
          </div>
        </Flex>
      </Flex>

      <Warning>
        <MdInfo color="#1976d2" size={22} />
        Selecione as sequências que serão {getWarningText()}.
      </Warning>

      <OperacoesTable operacoes={data ?? []} action={action} />
    </StyledModal>
  );
}

export default ModalMatriz;
